import * as React from "react";
import { Dialog, DialogContent, DialogTitle, Typography } from "@material-ui/core";
import TranslateNew from "@translate/TranslateNew";
import Button from "@components/common/button/Button";
import { buttonContained, buttonOutlined } from "src/main.style";
import { canOpenNativeSettings, openNativeSettings } from "@helpers/nativeSettings";

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Shown when a call cannot go ahead because camera or microphone access was refused.
 *
 * On a device it offers the way out: once Android has been told "don't allow" twice it
 * stops showing its own dialog, and the app's own settings page is the only place left to
 * turn the permission back on. Shared by the call screen and by the outgoing call button,
 * which both have to be able to explain the same dead end.
 */
const CallPermissionDialog: React.FC<IProps> = ({open, onClose}) => {
  const showSettingsButton = canOpenNativeSettings();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{tn.lang.callPermissionTitle}</DialogTitle>
      <DialogContent>
        <Typography>
          {showSettingsButton ? tn.lang.callPermission : tn.lang.callPermissionBrowser}
        </Typography>
      </DialogContent>
      <div style={{display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "row", gap: "10px", margin: "10px"}}>
        <Button variant='outlined' style={buttonOutlined} onClick={onClose}>
          {showSettingsButton ? tn.lang.cancel : tn.lang.close}
        </Button>
        {showSettingsButton && <Button
          variant='contained'
          style={buttonContained}
          color="primary"
          onClick={() => {onClose(); openNativeSettings();}}
        >
          {tn.lang.settings}
        </Button>}
      </div>
    </Dialog>
  );
}

export default CallPermissionDialog;



// WEBPACK FOOTER //
// ./src/components/calls/CallPermissionDialog.tsx